import {handleError} from "./utils";
import {api} from "./api-client";

export async function fetchPrices(start, end) {
    const {data} = await api().get(`/prices?start=${start}&end=${end}`).catch(handleError);
    return data
}